var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19498 0.205023C0.921607 -0.0683411 0.478395 -0.0683411 0.205023 0.205023C-0.0683411 0.478395 -0.0683411 0.921607 0.205023 1.19498L12.805 13.795C13.0784 14.0683 13.5216 14.0683 13.795 13.795C14.0683 13.5216 14.0683 13.0784 13.795 12.805L9.90977 8.91983L12.4315 5.9778C12.5402 5.85089 12.6 5.68933 12.6 5.52223V2.8C12.6 2.41341 12.2866 2.1 11.9 2.1H3.08995L1.19498 0.205023ZM4.48995 3.5L8.91689 7.92695L11.2 5.26329V3.5H4.48995Z",
    fill: "#50596B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40234 5.52134V3.78906L5.90048 8.87687C6.00926 9.00378 6.06904 9.16534 6.06904 9.33243V11.6279L7.93566 11.0057V10.3224L9.31032 11.697C9.24921 11.9178 9.08191 12.0993 8.85707 12.1743L5.59037 13.2632C5.37691 13.3343 5.14225 13.2986 4.95972 13.167C4.77718 13.0354 4.66902 12.8241 4.66902 12.5991V9.59143L1.57086 5.97691C1.46212 5.85 1.40234 5.68844 1.40234 5.52134Z",
    fill: "#50596B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear_icon.5aeb2ffa680cc0f01c15a9f8c471d6c8.svg";
export { ForwardRef as ReactComponent };